/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-transactions",
	props:{
		customerId: {
			default: null
		}
	},
	data() {
		return {
			customerTransactionHistory: [],
			customerTransactionHistoryHeadings: [
				{
					text: "Transaction #",
					field: "transactionId"

				},
				{
					text: "Transaction Date",
					field: "transactionDateString"
				
				},
				{
					text: "Transaction Type",
					field: "transactionType"
				},
				{
					text: "Total Amount For Purchase",
					field: "totalAmountForPurchaseAsString"
				},
				{
					text: "Total Points Gained",
					field: "totalValueInPointsEarned"
				},
				{
					text: "Total Points Used",
					field: "totalValueInPointsUsed"
				},
				{
					text: "Discount Received",
					field: "discountReceivedAsString"
				},
				{
					text: "Total Amount After Discount",
					field: "totalAmountAfterDiscountAsString"
				},
				{
					text: "Points Balance After Transaction",
					field: "totalValueInPointsAfterTransaction"
				}
			],
			actionKeys:{
				viewProductsPurchased: "viewProductPurchased"
			},
			transactionTypes: [],
			selectedTransactionId: null,
			customer: {},
			currentBalance: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			productsModalTable:{
				selectedTransactionId: null,
				products: [],
				showModal: false,
				modalId: "productsPurchasedModal",
				heading: "Products Purchased",
				headings: [
					{
						text: "Product Code",
						field: "productId"
					},
					{
						text: "barcode",
						field: "productBarcode"
					},
					{
						text: "Product Name",
						field: "productName"
					},
					{
						text: "Price",
						field: "priceString"
					},
					{
						text: "Quantity",
						field: "quantity"
					}
				],
				pagingDetails:{
					pageNumber: 1,
					pageSize: 10,
					totalPages: 1
				},
				searchQuery: null
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				selectedTransactionTypeId: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			let request = {
				personId: this.customerId
			};
			customerService.getCustomerPerson(this.customerId).then(
				response => {
					if(response.status === 200){
						this.customer = response.data.result;
						this.setBreadcrumbs();
					}
				}
			);
		},
		getTransactionHistory(){
			this.loading = true;
			let request = {
				personId: this.customerId,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				transactionDateFrom: this.filter.fromDateCreated === null ? null : moment(this.filter.fromDateCreated).format("DD/MM/YYYY"),
				transactionDateTo: this.filter.toDateCreated === null ? null : moment(this.filter.toDateCreated).format("DD/MM/YYYY"),
				searchQuery: this.filter.customerSearchQuery,
				transactionTypeId: this.filter.selectedTransactionTypeId === 0 ? null : this.filter.selectedTransactionTypeId
			};
			rewardsService.getCustomerTransactions(request).then(
				response => {
					if(response.status === 200){
						console.log("success", response);
						this.customerTransactionHistory = response.data.result;
						if(response.data.pagingInfo !== null){
							this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
							this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
						}
						this.customerTransactionHistory = dataTableHelper.castFieldValues(this.customerTransactionHistory);
						for(var i = 0; i < this.customerTransactionHistory.length; i++){
							this.customerTransactionHistory[i].amountAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].amount);
							this.customerTransactionHistory[i].currentBalanceAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].currentBalance);
							this.customerTransactionHistory[i].discountReceivedAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].totalDiscountReceived);
							this.customerTransactionHistory[i].totalAmountForPurchaseAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].totalAmountIncludingVat);
							this.customerTransactionHistory[i].totalAmountAfterDiscountAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].totalAmountAfterDiscountIncludingVat);
							this.customerTransactionHistory[i].actions = [
								{
									name: "View Product Purchased",
									key: this.actionKeys.viewProductsPurchased,
									elementId: "btnViewProductsPurchasedAction"
								}
							];
						}
					}
					this.loading = false;
					this.filterStateChanged = false;
				}
			);
		},
		getCurrentBalance(){
			this.loading = true;
			rewardsService.getCustomerAccount(this.customerId).then(
				response => {
					if(response.status === 200){
						console.log("success", response);
						this.currentBalance = response.data.result.currentPointBalance;
					}
					this.loading = false;
				}
			);
		},
		getTransactionTypes() {
			rewardsService.getTransactionTypes().then(
				response => {
					if(response.status === 200) {
						console.log("success", response);
						this.transactionTypes = response.data.result;
						this.transactionTypes = $.map(this.transactionTypes,
							function (obj) {
								obj.id = obj.id || obj.transactionTypeId;
								obj.text = obj.text || obj.description;
								return obj;
							});
						this.transactionTypes.unshift(
							{
								id: 0,
								text: "All"
							});
						this.filter.selectedTransactionTypeId = 0;
					}
				}
			);
		},
		exportTransactionsAsCsv(){
			this.loading = true;
			let request = {
				personId: this.customerId,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				transactionDateFrom: this.filter.fromDateCreated === null ? null : moment(this.filter.fromDateCreated).format("DD/MM/YYYY"),
				transactionDateTo: this.filter.toDateCreated === null ? null : moment(this.filter.toDateCreated).format("DD/MM/YYYY"),
				searchQuery: this.filter.customerSearchQuery,
				transactionTypeId: this.filter.selectedTransactionTypeId
			};
			rewardsService.exportCustomerTransactionsAsCsv(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'file.csv');
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getTransactionHistory();
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onTransactionTypeFilterSelect(transactionType){
			if(this.filter.selectedTransactionTypeId !== transactionType.id) {
				this.filterStateChanged = true;
			}
			this.filter.selectedTransactionTypeId = transactionType.id;
			// if(transactionType.id === 0){
			// 	this.filter.selectedTransactionTypeId = null;
			// }
			// else{
			// 	this.filter.selectedTransactionTypeId = transactionType.id;
			// }
			console.log("filter", this.filter);
		},
		getProductsPurchased(){
			let request = {
				transactionId: this.productsModalTable.selectedTransactionId,
				pageNumber: this.productsModalTable.pagingDetails.pageNumber,
				pageSize: this.productsModalTable.pagingDetails.pageSize,
				searchQuery: this.productsModalTable.searchQuery
			};
			this.productsModalTable.heading = "Products Purchased - Transaction #" + this.productsModalTable.selectedTransactionId;
			this.productsModalTable.showModal = true;
			rewardsService.getTransactionDetails(request).then(
				response => {
					if(response.status === 200){
						console.log("success", response);
						if(response.data.pagingInfo !== null){
							this.productsModalTable.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
							this.productsModalTable.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
						}
						this.productsModalTable.products = response.data.result;
						this.productsModalTable.products = dataTableHelper.castFieldValues(this.productsModalTable.products);
						for(var i = 0; i < this.productsModalTable.products.length; i++){
							this.productsModalTable.products[i].priceString = currencyHelper.numberToCurrency(this.productsModalTable.products[i].amountIncludingVat);
						}
					}
				}
			);
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getTransactionHistory();
		},
		onPagingUpdatedProducts(pagingInfo){
			this.productsModalTable.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getProductsPurchased();
		},
		onOkClicked() {
			this.productsModalTable.showModal = false;
		},
		onFilterSearchClickedProductTable(searchQuery){
			this.productsModalTable.searchQuery = searchQuery;
			this.productsModalTable.pagingDetails.pageNumber = 1;
			this.productsModalTable.pagingDetails.totalPages = 1;
			this.getProductsPurchased();
		},
		onTransactionActionClicked(actionAndData){
			switch(actionAndData.action){
				case this.actionKeys.viewProductsPurchased:
					console.log("View Products Purchased", actionAndData.data);
					this.productsModalTable.selectedTransactionId = actionAndData.data.transactionId;
					this.getProductsPurchased();
					break;
			}
		},
		setBreadcrumbs() {
			var pageTitle = "Transaction History - " + this.customer.firstName + " " + this.customer.lastName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.getTransactionTypes();
	},
	watch: {
		customerId: {
			handler: function () {
				if (this.customerId !== null && this.customerId > 0) {
					this.getTransactionHistory();
					this.getCurrentBalance();
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};